@if (dumpsters) {
  <div>
    <h5 translate="services.waste.stateTitle"></h5>
    @for (dumpster of dumpsters; track dumpster) {
      <div class="row">
        <h6 class="col-6"><strong>{{ dumpster['name' + crtLang.toUpperCase()] }}</strong></h6>
        @if (canDisplayDumpsterState(dumpster)) {
          <h6 class="col-6">
            @if (dumpster.deviceState === DeviceStateEnum.Error) {
              <span class="dot gray-border red"></span>
            }
            @if (dumpster.deviceState === DeviceStateEnum.Ready) {
              <span class="dot gray-border green"></span>
            }
            @if (dumpster.deviceState === DeviceStateEnum.Unknown) {
              <span class="dot gray-border gray"
              ></span>
            }
            {{ 'services.waste.enum.' + dumpster.deviceState | translate }}
          </h6>
        }
        @if (canDisplayDumpsterState(dumpster)) {
          <div class="col-12 text-muted small">{{ 'services.waste.message.state' | translate }}
          : {{ (dumpster.lastStateChanged | date : format) ?? '-' }}</div>
        }
        <div class="col-12 mb-4">{{ dumpster['description' + crtLang.toUpperCase()] }}</div>
      </div>
    }
    @if (dumpsters.length < 1) {
      <div>
        <p translate="services.waste.message.noDataAvailable"></p>
      </div>
    }
  </div>
}
